import React from "react";
import Loader from "@components/Loader";
import CategoryForm from "@components/catalog/CategoryForm";
import CategoryProductsManager from "@components/catalog/CategoryProductsManager";
import { useParams, useNavigate } from "react-router-dom";
import {
  useCategoryQuery,
  useSaveCategoryMutation,
  useCreateCategoryMutation
} from "@queries/catalog";
import "@styles/opencart-admin.css";

export default function CategoryEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const isNew = !id || id === "new";

  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  } = useCategoryQuery(isNew ? null : id);

  const saveMutation = useSaveCategoryMutation();     // update (keep as it was)
  const createMutation = useCreateCategoryMutation(); // create

  const cat = data?.data;

  const initial = React.useMemo(
    () =>
      isNew
        ? {
            id: null,
            parent_id: 0,
            image: "",
            top: 0,
            column: 1,
            sort_order: 0,
            status: 1,
            descriptions: {
              ar: {},
              en: {}
            }
          }
        : cat || {},
    [isNew, cat]
  );

  const onSubmit = async (payload) => {
    if (isNew) {
      await createMutation.mutateAsync(payload);
      navigate("/catalog");
    } else {
      await saveMutation.mutateAsync({ id, payload }); // same update style
      await refetch();
    }
  };

  const loading =
    isLoading || isFetching || saveMutation.isPending || createMutation.isPending;

  return (
    <div className="oc-content">
      {loading && <Loader />}

      <div className="oc-header">
        <h1>{isNew ? "Create Category" : "Edit Category"}</h1>
        <nav className="oc-bc">
          <span>Home</span>
          <span className="sep">›</span>
          <span>Catalog</span>
          <span className="sep">›</span>
          <span className="link" onClick={() => navigate("/catalog")}>
            Categories
          </span>
          <span className="sep">›</span>
          <span>{isNew ? "New" : id}</span>
        </nav>
      </div>

      {isError && !isNew && (
        <div className="oc-card" style={{ color: "#c00" }}>
          Error: {error.message}
        </div>
      )}

      <div className="oc-card">
        {(isNew || cat) && (
          <CategoryForm
            initial={initial}
            onSubmit={onSubmit}
            onCancel={() => navigate("/catalog")}
          />
        )}
      </div>

      {!isNew && cat && <CategoryProductsManager categoryId={id} />}
    </div>
  );
}

